<div class="terms-container">
  <div [innerHTML]="'Copyright' | cpLabelTranslate:['© ' + buildYear]  | async | cpBoldText:'© \\d+ Koninklijke Philips N.V.'"></div>
  <div class="terms-section" *ngIf="isNonMedicalDevice">{{'NonDiagnosticStatement' | cpLabelTranslate | async}}</div>
  <div class="terms-section" *ngIf="isUnreleasedDevice">{{'WarrantyDisclaimer' | cpLabelTranslate:['Philips Radiology Information System', commercialVersion] | async}}</div>


  <div class="terms-section">
      <img class="consult-symbol" [src]="resources.images.consultSymbol">
      <a class="consult-link" href="https://www.philips.com/IFU" target="_blank">www.philips.com/IFU</a>
      <img class="caution-symbol" [src]="resources.images.cautionSymbol" />
      <span *ngIf="isUnreleasedDevice"  class="caution-text" >{{'EvaluationPurposes' | cpLabelTranslate | async}}</span>
  </div>
</div>
